import { Socket } from 'socket.io-client'

export interface ReportPayload {
  type: string
  data: any
  timestamp: number
}

export interface SelfReportOptions {
  /** 上报事件名前缀，默认 'report:' */
  prefix?: string
}

/**
 * 客户端自报告协议
 * 主动上报状态/事件到服务端
 */
export class SelfReporter {
  private socket: Socket | null = null
  private prefix: string
  private queue: ReportPayload[] = []
  private maxQueueSize = 100

  constructor(options?: SelfReportOptions) {
    this.prefix = options?.prefix ?? 'report:'
  }

  /** 绑定 socket */
  bind(socket: Socket): void {
    this.socket = socket
    this.flushQueue()
  }

  /** 解绑 */
  unbind(): void {
    this.socket = null
  }

  /** 上报事件 */
  report(type: string, data: any): void {
    const payload: ReportPayload = { type, data, timestamp: Date.now() }
    if (this.socket?.connected) {
      this.socket.emit(`${this.prefix}${type}`, payload)
    } else {
      if (this.queue.length < this.maxQueueSize) {
        this.queue.push(payload)
      }
    }
  }

  /** 上报错误 */
  reportError(error: Error, context?: any): void {
    this.report('error', { message: error.message, stack: error.stack, context })
  }

  /** 上报状态变更 */
  reportStatus(status: string, details?: any): void {
    this.report('status', { status, ...details })
  }

  /** 上报自定义指标 */
  reportMetric(name: string, value: number, tags?: Record<string, string>): void {
    this.report('metric', { name, value, tags })
  }

  /** 获取待发送队列长度 */
  get pendingCount(): number {
    return this.queue.length
  }

  private flushQueue(): void {
    if (!this.socket?.connected) return
    const batch = this.queue.splice(0)
    for (const payload of batch) {
      this.socket.emit(`${this.prefix}${payload.type}`, payload)
    }
  }
}
